import useAuthStore from '../store/authStore';

// What the center's package unlocks (backend/config/plans.js), from the login /
// switch-center response. A center without a package — and a session stored
// before packages existed — keeps everything; the backend enforces it anyway.
export const ALL_FEATURES = Object.freeze({ whatsapp: true });

export function planFeaturesOf(user) {
  return { ...ALL_FEATURES, ...(user?.planFeatures || {}) };
}

export default function usePlanFeatures() {
  const user = useAuthStore((s) => s.user);
  return planFeaturesOf(user);
}

/** Menu paths that are WhatsApp features. */
export const WHATSAPP_PATHS = ['/settings/whatsapp-templates', '/whatsapp/bulk-send', '/whatsapp/inbox'];
